import { render } from "./TopMenuList.vue?vue&type=template&id=b185a9a6"
import script from "./TopMenuList.vue?vue&type=script&lang=js"
export * from "./TopMenuList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__